<template>
  <div>
    <van-nav-bar
      :title="$t('app.withdrawal_inquiry.title')"
      left-text=""
      left-arrow
      @click-left="$router.push('/member/members')"
    />
    <van-list
      v-model="loadingWithdrawal"
      :finished="finishedWithdrawal"
      :finished-text="$t('app.common.finished')"
    >
      <div class="tableContent">
        <table class="stockTable" cellspacing="0" cellpadding="0" border="0">
          <tr class="tableheading">
            <th>{{$t("app.withdrawal_inquiry.name")}}</th>
            <th>{{$t("app.withdrawal_inquiry.direction")}}</th>
            <th>{{$t("app.withdrawal_inquiry.price")}}</th>
            <th>{{$t("app.withdrawal_inquiry.quantity")}}</th>
            <th>{{$t("app.withdrawal_inquiry.unsold")}}</th>
            <th>{{$t("app.withdrawal_inquiry.status")}}</th>
            <th>{{$t("app.withdrawal_inquiry.trade_direction")}}</th>
            <th>{{$t("app.withdrawal_inquiry.time")}}</th>
          </tr>
          <tr
            class="stock_td"
            v-for="(item, index) in all_cancel"
            :key="index"
            style="font-size: 14px"
          >
            <td>
              <p>
                <span
                  style="
                    white-space: nowrap;
                    overflow: hidden !important;
                    text-overflow: ellipsis;
                  "
                  >{{ item.name }}</span
                ><br /><span>{{ item.code_new }}</span>
              </p>
            </td>
            <td>
              <p style="color: red">{{ item.type }}</p>
            </td>
            <td>
              <p>{{ item.deal }}</p>
            </td>
            <td>
              <p>{{ item.number }}</p>
            </td>
            <td>
              <p>{{ item.surplus }}</p>
            </td>
            <td>
              <p style="color: red">{{ item.status }}</p>
            </td>
            <td>
              <p>{{ item.direction }}</p>
            </td>
            <td>
              <p>{{ $getDeviceTime(item.time) }}</p>
            </td>
          </tr>
        </table>
      </div>
    </van-list>
  </div>
</template>

<script>
export default {
  name: "WithdrawalInquiry",
  data() {
    return {
      all_cancel: [],
      finished: false,
      loadingWithdrawal: false,
      finishedWithdrawal: false,
    };
  },

  methods: {
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    getAllCancel() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "all_cancel",
            token: window.sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (resData.code == 1) {
            that.all_cancel = resData.data;
            that.loadingWithdrawal = false;
            that.finishedWithdrawal = true;
          } else if (resData.code == 0 || resData.code == -1) {
            that.$toast.fail(that.$t(res.data.msg));
          }
        })
        .catch(() => {
          that.loadingWithdrawal = false;
          that.$toast.fail(that.$NoNetworkErrorMsg);
        });
    },
  },
  mounted: function () {
    let that = this;
    that.isLogin();
    that.getAllCancel();
  },
};
</script>

<style scoped>
.navstyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}

.tableheading {
  font-size: 14px;
  /* position: sticky;
  top: 46px; */
  padding-bottom: 10px;
  text-align: center;
  background: #ffffff;
  height: 45px;
  line-height: 45px;
}

.stockTable {
  /* margin-top: 10px; */
  text-align: left;
  width: 650px;
  padding: 0px 10px;
}

.stockTable th,
.stockTable td {
  width: 80px;
  text-align: center;
}

.stock_td p {
  margin: 5px 0px;
}

.tableContent {
  /* margin-top: 10px; */
  overflow-y: hidden;
  overflow-x: scroll;
  width: 100vw;
}
</style>



// WEBPACK FOOTER //
// src/components/WithdrawalInquiry.vue